export const gradesFivePlusPoemsAndPassagesIntroSteps = [
  {
    element: '#resources-title',
    intro: 'Poems & Passages is where you can download all of the connected text students are reading and listening to in the WordFlight System. WordFlight recommends all students read aloud with their teacher weekly.'
  },
  {
    element: '#backButton',
    intro: 'Click here to go back to the Grades 5+ menu page.'
  },
  {
    element: '#resourcesTableHeader',
    intro: 'Scroll until you find the unit connected texts you want to download. Click the file to download it.'
  }
];